import { buildBillingContext } from '@/apiCalls/billingContext';
import { postUrl } from '@/apiCalls/fetch';
import { trackedServiceCall } from '@/apiCalls/uniqueIDTransferHelper';
import { setVehicle } from '@/context/borrower';
import { store } from '@/context/store';
import {
    EParameters,
    getCaseInsensitiveParam,
    getCaseInsensitiveParamFromList,
    getParameters,
} from '@/utils/setParametersFromParams';

import { IVehicleReturn } from './lookupVinTypes';

export async function lookupVin(partnerId: string): Promise<boolean> {
    const state = store.getState();
    const stateVin = state.borrowerReducer.vehicle.vin;
    const stateVehicle = state.borrowerReducer.vehicle;
    const disabledGlassesGuideVinLookup =
        state.displayReducer.partner.disabledGlassesGuideVinLookup;

    if (!stateVin) return false;

    if (disabledGlassesGuideVinLookup) {
        console.log('Glasses guide VIN lookup is disabled for this brand');
        return false;
    }

    const params = getParameters();
    const urlBuildYear = getCaseInsensitiveParamFromList(params, [
        EParameters.BUILD_YEAR,
        'buildyear',
        'buildYear',
        'BUILD_YEAR',
        'BUILDYEAR',
    ]);
    const urlMake = getCaseInsensitiveParam(params, EParameters.MAKE);

    if (urlBuildYear && urlMake) {
        return false;
    }

    const url = `/api/asset/select/${partnerId}/vin/${stateVin}`;
    try {
        const data = await trackedServiceCall('assetLookupVin', () =>
            postUrl<IVehicleReturn>(url, {
                billingContext: buildBillingContext(),
            })
        );

        if (!data) return false;

        const {
            make,
            model,
            vin,
            nvic,
            variant,
            buildYear,
            glassValuation,
            description,
            bodyType,
        } = data;

        const isVehicleKnown = glassValuation ? true : false;

        store.dispatch(
            setVehicle({
                ...stateVehicle,
                make,
                model,
                nvic,
                vin,
                variant,
                buildYear,
                glassValuation,
                description,
                bodyType,
                isVehicleKnown,
            })
        );

        return isVehicleKnown;
    } catch (error) {
        console.log('Error looking up VIN', error);
        return false;
    }
}
